import { render, staticRenderFns } from "./ClubsIndex.vue?vue&type=template&id=0e1dfd91"
import script from "./ClubsIndex.js?vue&type=script&lang=js&external"
export * from "./ClubsIndex.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports